import { render, staticRenderFns } from "./markInfoBi.vue?vue&type=template&id=19a80445&scoped=true"
import script from "./markInfoBi.vue?vue&type=script&lang=js"
export * from "./markInfoBi.vue?vue&type=script&lang=js"
import style0 from "./markInfoBi.vue?vue&type=style&index=0&id=19a80445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a80445",
  null
  
)

export default component.exports